import { ApiError } from '../api/client';

/** Spanish text for API errors the user can act on; `specific` overrides by HTTP status for one screen. */
export function describeApiError(error: unknown, fallback: string, specific: Partial<Record<number, string>> = {}): string {
  if (!(error instanceof ApiError)) return fallback;
  const byStatus: Partial<Record<number, string>> = {
    429: 'Has hecho demasiadas peticiones seguidas. Espera un minuto y vuelve a intentarlo.',
    502: 'El servicio que genera los PDF no responde. Inténtalo de nuevo en unos minutos.',
    ...specific,
  };
  return byStatus[error.status] ?? error.message;
}
